<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-native-builds-hero-section id="hero"></app-native-builds-hero-section>
  <!-- Video -->
  <app-video-section
    id="video"
    src="assets/videos/native-builds-demo.mp4"
  ></app-video-section>
  <!-- Social Proof -->
  <app-customer-logo-section id="customers"></app-customer-logo-section>
  <!-- How it works -->
  <app-native-builds-how-it-works-section
    id="how-it-works"
  ></app-native-builds-how-it-works-section>
  <!-- Features -->
  <app-native-builds-features-section
    id="features"
  ></app-native-builds-features-section>
  <!-- Android -->
  <app-native-builds-android-section
    id="android"
  ></app-native-builds-android-section>
  <!-- iOS -->
  <app-native-builds-ios-section id="ios"></app-native-builds-ios-section>
  <!-- Build Stack -->
  <!-- <app-native-builds-build-stack-section
    id="build-stack"
  ></app-native-builds-build-stack-section> -->
  <!-- Integrations -->
  <app-native-builds-integrations-section
    id="integrations"
  ></app-native-builds-integrations-section>
  <!-- CLI -->
  <app-native-builds-cli-section id="cli"></app-native-builds-cli-section>
  <!-- Security -->
  <app-native-builds-security-section
    id="security"
  ></app-native-builds-security-section>
  <!-- Statistics -->
  <app-native-builds-statistics-section
    id="statistics"
  ></app-native-builds-statistics-section>
  <!-- Social Proof -->
  <app-testimonials-section id="testimonials"></app-testimonials-section>
  <!-- Blog -->
  <app-blog-section id="blog" [posts]="blogPosts"></app-blog-section>
  <!-- FAQ -->
  <app-native-builds-faq-section id="faq"></app-native-builds-faq-section>
  <!-- CTA -->
  <app-native-builds-cta-section id="cta"></app-native-builds-cta-section>
</div>
